var _rect, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOpenInterest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.800781,
    width: 60,
    height: 60,
    rx: 16,
    fill: "url(#paint0_linear_4255_14366)",
    fillOpacity: 0.15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4255_14366)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9603 19.7508H35.0085V33.7176L31.1703 33.7176L36.4815 42.9168L41.7926 33.7176H37.9603V19.7508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6026 41.4425L23.2646 41.4425V27.4741L19.6214 27.4741L24.9326 18.2749L30.2437 27.4741L26.6026 27.4741L26.6026 41.4425Z",
    fill: "#03F5AE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4255_14366",
    x1: 9.80078,
    y1: 2,
    x2: 60.8008,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F5AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F5AE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4255_14366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(12.8008 12)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenInterest);
export default __webpack_public_path__ + "static/media/openInterest.57bb78169113c7adc2bc9bd9472ad3a3.svg";
export { ForwardRef as ReactComponent };